<template>
  <div>
    <el-dialog
      title="采购申请单"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div>
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :data.sync="selfDetail.formData"
          />
          <div class="flex flex-y-center m-t-10">
            <div class="group-title">物料清单</div>
            <el-link class="m-b-5 m-l-10" type="primary" size="mini" @click="chooseYuanLiao">
              <span>选择单号</span>
              <span class="c-red">({{ selfDetail.list.length }})</span>
            </el-link>
          </div>
          <vxe-grid
            ref="refTable"
            :min-height="tableConfig.minHeight"
            :toolbar-config="tableConfig.toolbarConfig"
            :edit-config="tableConfig.editConfig"
            :row-config="tableConfig.rowConfig"
            :mouse-config="tableConfig.mouseConfig"
            :keyboard-config="tableConfig.keyboardConfig"
            :columns="tableColumn"
            :data="selfDetail.list"
            :show-footer="!!selfDetail.list.length"
            :max-height="this.$util.getViewHeight() - 500"
            :footer-method="tableFooterMethod"
          >
            <!-- slot_default -->
            <template #default_list_chan_pin_tu="{ row }">
              <e-upload-image :list.sync="row.list_chan_pin_tu" :limit="5" isDelete />
            </template>
            <template #default_shen_gou_amount="{ row }">
              <span class="c-orange">{{ row.shen_gou_amount }}</span>
            </template>
            <template #default_operate="{ rowIndex }">
              <el-link
                class="f-s-16 iconfont icon-delete"
                title="删行"
                @click="itemDelete(rowIndex)"
              />
            </template>

            <!-- slot_edit -->
            <template #edit_name="{ row }">
              <el-input v-model="row.name" size="mini" clearable />
            </template>
            <template #edit_spec="{ row }">
              <el-input v-model="row.spec" size="mini" clearable />
            </template>
            <template #edit_unit="{ row }">
              <el-input v-model="row.unit" size="mini" clearable />
            </template>
            <template #edit_counts="{ row }">
              <el-input v-model="row.counts" type="number" size="mini" clearable />
            </template>
            <template #edit_shen_gou_counts="{ row }">
              <el-input
                v-model="row.shen_gou_counts"
                type="number"
                size="mini"
                clearable
                @blur="countsBlur(row)"
              />
            </template>
            <template #edit_goods_price="{ row }">
              <el-input
                v-model="row.goods_price"
                type="number"
                size="mini"
                clearable
                @blur="countsBlur(row)"
              />
            </template>
            <template #edit_remark="{ row }">
              <el-input v-model="row.remark" size="mini" clearable />
            </template>
          </vxe-grid>
          <div>
            <div class="group-title m-t-20">其他要求</div>
            <div
              v-for="(item, index) in selfDetail.formData.qi_ta_yao_qiu_list"
              :key="index"
              class="yao-qiu-item"
            >
              <div>要求{{ index + 1 }}:</div>
              <div class="flex-1">
                <el-input
                  v-model="item.qi_ta_yao_qiu"
                  size="mini"
                  placeholder="请输入..."
                  clearable
                />
              </div>
              <div>
                <el-link
                  class="m-l-5 f-s-16 iconfont icon-add"
                  title="增行"
                  @click="yaoqiuItemAdd(index)"
                />
                <el-link
                  :disabled="selfDetail.formData.qi_ta_yao_qiu_list.length < 3"
                  class="f-s-16 iconfont icon-delete"
                  title="删行"
                  @click="yaoqiuItemDelete(index)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupPush(false)">提交</el-button>
        <el-button size="mini" type="primary" @click="popupPush(true)">打印预览</el-button>
      </div>
    </el-dialog>
    <PopupChooseYuanLiao
      ref="refPopupChooseYuanLiao"
      v-if="isShowPopupChooseYuanLiao"
      :show.sync="isShowPopupChooseYuanLiao"
      :list="selfDetail.list"
      @success="chooseYuanLiaoSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseYuanLiao: () => import('./popup-choose-yuan-liao')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    code: {
      type: [Number, String],
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selfShow: false,
      // 供应商完整数据列表，用于联动查询联系人与电话
      supplierList: [],
      selfDetail: {
        formData: {
          shen_gou_code: '', // 采购申请单号
          shen_qing_ren_name: '', // 申请人
          shen_qing_ren_id: '', // 申请人ID
          shen_qing_bu_men_name: '', // 申请部门
          shen_qing_bu_men_id: '', // 申请部门ID
          shen_gou_type: '物料采购', // 采购申请类型
          shen_gou_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 申请日期
          qi_wang_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 期望交期
          qi_ta_yao_qiu_list: [{ qi_ta_yao_qiu: '' }, { qi_ta_yao_qiu: '' }], // 其他要求
          ke_fu_name: '', // 客服
          supplier_name: '', // 供应商
          supplier_fu_ze_ren: '', // 供应商负责人
          supplier_phone: '' // 供应商电话
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '386px'
      },
      formColumn: [
        {
          type: 'text',
          title: '采购申请单号',
          field: 'shen_gou_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '申请人',
          field: 'shen_qing_ren_name',
          disabled: true
        },
        {
          type: 'text',
          title: '申请部门',
          field: 'shen_qing_bu_men_name',
          disabled: true
        },
        {
          type: 'select',
          title: '采购类型',
          field: 'shen_gou_type',
          options: [
            { key: '物料采购', val: '物料采购' },
            { key: '办公用品', val: '办公用品' },
            { key: '劳保用品', val: '劳保用品' },
            { key: '设备零配件', val: '设备零配件' },
            { key: '清洁用品', val: '清洁用品' },
            { key: '其他', val: '其他' }
          ]
        },
        {
          type: 'date',
          title: '申请日期',
          field: 'shen_gou_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'date',
          title: '期望交期',
          field: 'qi_wang_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '客服',
          field: 'ke_fu_name'
        },
        {
          type: 'autocomplete',
          title: '供应商',
          field: 'supplier_name',
          // 供应商建议列表：输入时实时过滤，可不匹配自由输入
          querySearch: (queryString, callback) => {
            let list = this.supplierList.map((item) => ({ value: item.supplier_name }))
            let result = queryString
              ? list.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()))
              : list
            callback(result)
          }
        },
        {
          type: 'text',
          title: '供应商负责人',
          field: 'supplier_fu_ze_ren'
        },
        {
          type: 'text',
          title: '供应商电话',
          field: 'supplier_phone'
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '销售订单',
          field: 'bill_code'
        },
        {
          title: '物料图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '物料名称',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '物料类型',
          field: 'wu_liao_type',
          width: 60
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120,
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'unit',
          width: 60,
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '需求数量',
          field: 'counts',
          width: 80,
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '本次申购数量',
          field: 'shen_gou_counts',
          width: 100,
          slots: { edit: 'edit_shen_gou_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          width: 80,
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'shen_gou_amount',
          slots: { default: 'default_shen_gou_amount' },
          width: 80
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '操作',
          slots: { default: 'default_operate' },
          width: 60
        }
      ],
      isShowPopupChooseYuanLiao: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    accountInfo() {
      return this.$store.state.loginAccount
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 监听供应商变化，联动填充负责人与电话
    // 匹配到下拉项时带出联系人/电话；未匹配（手动输入）时保留现有值由用户自行填写
    'selfDetail.formData.supplier_name'(val) {
      if (val && this.supplierList.length) {
        let target = this.supplierList.find((item) => item.supplier_name === val)
        if (target) {
          this.selfDetail.formData.supplier_fu_ze_ren = target.linkman || ''
          this.selfDetail.formData.supplier_phone = target.linkman_phone || ''
        }
      } else if (!val) {
        // 清空供应商时同步清空负责人与电话
        this.selfDetail.formData.supplier_fu_ze_ren = ''
        this.selfDetail.formData.supplier_phone = ''
      }
    }
  },
  mounted() {
    this.selfShow = this.show
    // 获取供应商列表
    this.getSupplierList()
    if (this.code) {
      this.getDetailData()
    } else {
      this.selfDetail.formData.shen_qing_bu_men_name = this.accountInfo.bu_men_name.join(',')
      this.selfDetail.formData.shen_qing_bu_men_id = this.accountInfo.bu_men_id.join(',')
      this.selfDetail.formData.shen_qing_ren_name = this.accountInfo.nick_name
      this.selfDetail.formData.shen_qing_ren_id = this.accountInfo.id
      let result = this.$util.deepCopy(this.list)
      result.forEach((item) => {
        let bind_id = item.id
        item.id = ''
        item.bind_id = bind_id
      })
      this.chooseYuanLiaoSuccess(result)
    }
  },
  methods: {
    // 选择物料
    chooseYuanLiao() {
      this.isShowPopupChooseYuanLiao = true
    },
    chooseYuanLiaoSuccess(list) {
      let resultOld = this.$util.deepCopy(this.selfDetail.list)
      let resultNew = this.$util.deepCopy(list)
      let resultStart = []
      let resultEnd = []
      resultOld.forEach((itemSt) => {
        let isRepect = resultNew.some((itemNd) => itemNd.bind_id === itemSt.bind_id)
        if (isRepect) {
          resultStart.push(itemSt)
        }
      })
      resultNew.forEach((itemSt) => {
        let isRepect = resultOld.some((itemNd) => itemNd.bind_id === itemSt.bind_id)
        if (!isRepect) {
          // 初始化绑定数量、金额、备注
          itemSt.shen_gou_counts = itemSt.counts
          itemSt.shen_gou_amount = this.$XEUtils.multiply(
            itemSt.goods_price,
            itemSt.shen_gou_counts
          )
          itemSt.remark = ''
          resultEnd.push(itemSt)
        }
      })
      this.selfDetail.list = [...resultStart, ...resultEnd]
    },
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengou3/detailShenGouCode',
        params: {
          code: this.code
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let len = res.data.formData.qi_ta_yao_qiu_list.length
          if (len === 0) {
            res.data.formData.qi_ta_yao_qiu_list.push({ qi_ta_yao_qiu: '' }, { qi_ta_yao_qiu: '' })
          }
          if (len === 1) {
            res.data.formData.qi_ta_yao_qiu_list.push({ qi_ta_yao_qiu: '' })
          }
          // 确保供应商相关字段存在，防止详情回显时字段缺失
          if (!res.data.formData.supplier_name) res.data.formData.supplier_name = ''
          if (!res.data.formData.supplier_fu_ze_ren) res.data.formData.supplier_fu_ze_ren = ''
          if (!res.data.formData.supplier_phone) res.data.formData.supplier_phone = ''
          this.selfDetail = this.$util.deepCopy(res.data)
        }
      })
    },
    /**
     * 获取供应商列表（供应商 autocomplete 数据源与联动查询）
     * 用于供应商下拉建议列表与选择后带出负责人/电话
     */
    getSupplierList() {
      this.$api({
        method: 'post',
        url: '/admin/supplier',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          },
          filterData: {}
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            // 保存完整数据用于 autocomplete 建议与负责人/电话联动
            this.supplierList = res.data.page.list || []
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    /**
     * 表格底部合计方法
     * 重新计算每行申购金额，确保合计值为最新结果
     */
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let price = Number(item.goods_price)
        let counts = Number(item.shen_gou_counts)
        item.shen_gou_amount = this.$XEUtils.multiply(price, counts)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['shen_gou_counts', 'goods_price', 'shen_gou_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    /**
     * 单价或申购数量失焦时自动计算金额
     * @param {Object} row 当前行数据
     */
    countsBlur(row) {
      row.shen_gou_amount = this.$XEUtils.multiply(
        Number(row.goods_price),
        Number(row.shen_gou_counts)
      )
    },
    // 项-删除
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 要求项-新增
    yaoqiuItemAdd(index) {
      this.selfDetail.formData.qi_ta_yao_qiu_list.splice(index + 1, 0, { qi_ta_yao_qiu: '' })
    },
    // 要求项-删除
    yaoqiuItemDelete(index) {
      this.selfDetail.formData.qi_ta_yao_qiu_list.splice(index, 1)
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush(isPushAndPrint) {
      let data = this.$util.deepCopy(this.selfDetail)
      data.formData.qi_ta_yao_qiu_list = data.formData.qi_ta_yao_qiu_list.filter(
        (item) => item.qi_ta_yao_qiu
      )
      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengou3/saveOrUpdate',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
            if (isPushAndPrint) this.popupPrint(res.data.code)
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    },
    // 项-打印
    popupPrint(code) {
      window.open(`/new/purchase/apply/print?code=${code}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .yao-qiu-item {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
}
</style>
